export const DEFAULT_BANNER_CONSTANTS = {
  imagePath: 'assets/images/svg/default-banner-image.svg',
  cssVariable: '--themed-default-banner-image',
  mimeType: 'image/svg+xml',
  errors: {
    loadFailed: 'Failed to load default banner image'
  }
} as const;
